import { request, HTTPError, TimeoutError, getJwtToken } from '@fingermarkglobal/request';
import { check } from '@fingermarkglobal/validation';
import { PreOrderPayload } from '@fingermarkglobal/types';
import { buildRequestOptions, providerRequestFormatter } from '../helpers';

const preOrder = async (
  payload: PreOrderPayload,
  timeout: number = 30,
  ip?: string,
  provider: string = '',
) => {
  logger.info('[@fingermarkglobal/fm-api] preOrder started');

  try {
    const localIp = JSON.parse(process.env.POI_APP_HAWKE_ORDER_LOCAL_IP || 'false');
    const endpoint = providerRequestFormatter(
      process.env.POI_APP_HAWKE_PRE_ORDER_ENDPOINT,
      provider,
    );
    const jwtToken = await getJwtToken();
    const invalid = check({
      name: 'Pre-order',
      parameters: { payload },
    });

    if (invalid)
      throw new Error(`[@fingermarkglobal/fm-api] Failed to validate parameters [${invalid}]`);
    if (!endpoint)
      throw new Error(
        `[@fingermarkglobal/fm-api] Failed to get pre order endpoint in the environment file with the key POI_APP_HAWKE_PRE_ORDER_ENDPOINT.`,
      );
    if (!jwtToken)
      throw new Error(
        `[@fingermarkglobal/fm-api] Request made successfully, but an empty response was received`,
      );

    const { endpoint: formattedEndpoint, params } = buildRequestOptions(
      endpoint,
      payload,
      jwtToken,
      timeout,
      ip,
      localIp,
    );

    const response = await request.post(formattedEndpoint, params).json();

    if (!response)
      throw new Error(`[@fingermarkglobal/fm-api] Request failed. Response {${response}}`);

    logger.info('[@fingermarkglobal/fm-api] preOrder finished');

    return response;
  } catch (err) {
    if (err instanceof HTTPError || err instanceof TimeoutError) throw err;
    logger.error('[@fingermarkglobal/fm-api] Error in preOrder:', err);
    throw err;
  }
};

export { preOrder };
